import { Component, Inject, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";

import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { AttachmentDocComponent } from "../../../../shared/attachment-doc/attachment-doc.component";
import { IDocument } from "../../../../interfaces/i-document";
import { IAgentSummary } from "../../../../interfaces/i-agents";
import { ThemeColor } from "../../../../enums/api.enum";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: 'session-details-list',
  imports: [
    MatListModule,
    MatButtonModule,
    MatIconModule,
    AttachmentDocComponent
],
  templateUrl: './session-details-list.component.html',
  styleUrl: './session-details-list.component.scss'
})
export class SessionDetailsListComponent {
  agents: IAgentSummary[] = [];
  documents: IDocument[] = [];
  topP: number = 0;
  temperature: number = 0;
  model: string = '';
  #bottomSheetRef = inject<MatBottomSheetRef<SessionDetailsListComponent>>(MatBottomSheetRef);

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: {
    agents: IAgentSummary[],
    documents: IDocument[],
    meta: { topP: number, temperature: number, model: string }
    themeColor: ThemeColor
  }) {
    this.agents = data.agents;
    this.documents = data.documents;
    this.topP = data.meta.topP;
    this.temperature = data.meta.temperature;
    this.model = data.meta.model;
  }

  closeNotification(event: MouseEvent): void {
    this.#bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
